<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Заказчики
                </div>
                <div class="ap-workspace-label-btn" v-on:click="addCustomer">
                    <SVGPlus/>
                </div>
            </div>
            <div class="ap-workspace-label-btn ap-add-left-margin">
                <label class="ap-search">
                    <input type="text" class="ap-search-input" placeholder="Найти заказчика" v-model="mask">
                </label>
            </div>
        </div>
        <vue-custom-scrollbar @ps-y-reach-end="scrollReachEnd">
            <div class="ap-workspace-table-container workspace-admin-scroll-part">
                <table class="result-table">
                    <thead>
                    <tr class="head-tr">
                        <th>№</th>
                        <th>ФИО</th>
                        <th>Телефон</th>
                        <th>E-mail</th>
                        <th>Город</th>
                        <th class="field-edit">Опции</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="body-tr row" v-for="(value, index) in customers">
<!--                        <td>-->
<!--                            <div class="ap-table-uuid-holder" v-on:click="showModalUUID(value.uuid)">-->
<!--                                <SVGLabel style="margin: 2px 0"/> UUID-->
<!--                            </div>-->
<!--                            <span class="table-data-central">{{value.uuid}}</span>-->
<!--                        </td>-->
                        <td>
                            <span class="table-data">{{index+1}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.name}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.phone}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.email}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.city}}</span>
                        </td>
                        <td>
                            <div class="edit-button-group">
                                <div class="table-svg-button" v-on:click="editRow(value)">
                                    <SVGAdminEditRow/>
                                </div>
                                <div class="table-svg-button" v-on:click="confirm(value)">
                                    <SVGAdminDeleteRow/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="waitingResponseToCustomersRequest" class="ap-loader-grid">
                    <SpinnerTwo/>
                    <div class="ap-loader-text">
                        Идет загрузка заказчиков ...
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow.vue";
    import SVGPlus from "../../SVG/SVGPlus";
    import {modalMethods, urlForStaticVue} from "../../common";
    import SVGSearch from "../../SVG/SVGSearch";
    import AddCustomer from "../../Modal/AdminPage/CustomersPage/AddCustomer";
    import ChangeCustomer from "../../Modal/AdminPage/CustomersPage/ChangeCustomer";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../../SpinnerTwo";
    import ModalUUID from "../../Modal/AdminPage/ModalUUID";
    import SVGLabel from "../../SVG/SVGLabel";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "AdminCustomers",
        mixins: [urlForStaticVue, modalMethods],
        components: {
            SVGLabel,
            SpinnerTwo,
            SVGSearch,
            SVGPlus,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        data(){
            return {
                timerId: null
            }
        },
        computed:{
            mask:{
                get() {
                    return this.$store.state.adminPanel.customers.mask;
                },
                set(value) {
                    this.$store.commit('adminPanel/customers/MASK', value);
                    if (this.timerId) {
                        clearTimeout(this.timerId);
                        this.timerId = null;
                    }
                    this.timerId = setTimeout(() => {
                        this.$store.commit('adminPanel/customers/CLEAR_CUSTOMERS');
                        this.$store.dispatch('adminPanel/customers/GET_CUSTOMERS');
                        this.timerId = null;
                    }, 500);
                }
            },
          customers(){
              return this.$store.getters["adminPanel/customers/SELF"];
          },
          waitingResponseToCustomersRequest() {
              return this.$store.state.adminPanel.customers.waitingResponseToCustomerRequest;
          }
        },
        methods: {
            scrollReachEnd() {
                this.$store.dispatch('adminPanel/customers/GET_CUSTOMERS');
            },
            editRow(dataCustomer) {
                this.$modal.show(ChangeCustomer, {dataCustomer}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 450,
                    draggable: true,
                });
            },
            deleteRow(customerUUID) {
                return () => {this.$store.dispatch('adminPanel/customers/DELETE_CUSTOMER', customerUUID)};
            },
            confirm(customer) {
                const title = `Удалить заказчика "${customer.name}"?`
                const text = 'Запись о данном заказчке будет безвозвратно удалена, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteRow(customer.uuid)}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            addCustomer(){
                this.$modal.show(AddCustomer, {}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 450,
                    draggable: true,
                });
            },
            // showModalUUID(uuid) {
            //     this.$modal.show(ModalUUID, {uuid}, {
            //         height: 'auto',
            //         pivotY: 0.2,
            //         width: 516
            //     });
            // }
        },
        mounted() {
            this.$store.dispatch('adminPanel/customers/GET_CUSTOMERS');
        }
    }
</script>

<style scoped>

</style>
